import React from 'react';
import { Dialog } from '@mui/material';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const ModalCross = styled.div`
  color: black;
  outline: 0;
  position: absolute;
  right: 0;
  .modal_close i {
    font-size: 16px;
    cursor: pointer;
    margin: 12px;
    color: ${(props) => props.theme.primaryDarkColor};
  }
`;

const DialogBox = ({ children, open, onClose, width, crossButton = false }) => {
  return (
    <Dialog
      PaperProps={{
        style: { borderRadius: '15px' },
      }}
      style={{ zIndex: 16000 }}
      maxWidth={width}
      open={open}
      onClose={onClose}
    >
      {crossButton && (
        <ModalCross>
          <span className="modal_close">
            <Icon name="close" onClick={onClose} />
          </span>
        </ModalCross>
      )}
      {children}
    </Dialog>
  );
};
export default DialogBox;
